export default {"src":"/_next/static/media/URBN.c37100a9.svg","height":18,"width":18};